/* ==========================================================================
   COFFAO — Concept A « Le Passeport »
   Vanilla JS, aucune dépendance. Chargé en defer.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------- Marquee : duplication du contenu ---------------- */
  function initMarquee(root) {
    root.querySelectorAll('[data-cpx-marquee]').forEach(function (ul) {
      if (ul.dataset.cpxDone) return;
      ul.dataset.cpxDone = '1';
      ul.innerHTML = ul.innerHTML + ul.innerHTML;
    });
  }

  /* ---------------- Filtres de la grille boutique ---------------- */
  function initFilters(root) {
    root.querySelectorAll('[data-cpx-filters]').forEach(function (bar) {
      if (bar.dataset.cpxDone) return;
      bar.dataset.cpxDone = '1';
      var scope = bar.closest('[data-cpx-grid-section]');
      if (!scope) return;
      var cards = scope.querySelectorAll('[data-cpx-card]');
      var empty = scope.querySelector('[data-cpx-empty]');

      bar.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cpx-filter]');
        if (!btn) return;
        var f = btn.getAttribute('data-cpx-filter');
        bar.querySelectorAll('[data-cpx-filter]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        var shown = 0;
        cards.forEach(function (c) {
          var match = f === 'all' || c.getAttribute('data-cpx-profil') === f;
          c.classList.toggle('is-hidden', !match);
          if (match) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      });
    });
  }

  /* ---------------- Jauges animées à l'entrée dans le viewport ------- */
  function initGauges(root) {
    var bars = root.querySelectorAll('[data-cpx-gauge]:not([data-cpx-done])');
    if (!bars.length) return;
    var fill = function (el) {
      el.setAttribute('data-cpx-done', '1');
      el.style.width = (el.getAttribute('data-cpx-gauge') || '0') + '%';
    };
    if (!('IntersectionObserver' in window)) {
      bars.forEach(fill);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { fill(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.25 });
    bars.forEach(function (b) { io.observe(b); });
  }

  /* ---------------- Galerie fiche produit ---------------- */
  function initGallery(root) {
    root.querySelectorAll('[data-cpdp-gallery]').forEach(function (gal) {
      if (gal.dataset.cpxDone) return;
      gal.dataset.cpxDone = '1';
      var main = gal.querySelector('[data-cpdp-gallery-main]');
      if (!main) return;
      gal.addEventListener('click', function (e) {
        var t = e.target.closest('[data-cpdp-thumb]');
        if (!t) return;
        var src = t.getAttribute('data-cpdp-thumb');
        var alt = t.getAttribute('data-cpdp-alt') || '';
        main.innerHTML = '<img src="' + src + '" alt="' + alt.replace(/"/g, '&quot;') + '" width="1000" height="1000">';
        gal.querySelectorAll('[data-cpdp-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', String(b === t));
        });
      });
    });
  }

  /* ---------------- Sélecteur de variante ---------------- */
  function initVariants(root) {
    root.querySelectorAll('[data-cpdp-product]').forEach(function (scope) {
      if (scope.dataset.cpxDone) return;
      scope.dataset.cpxDone = '1';

      var dataEl = scope.querySelector('[data-cpdp-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var idInput   = scope.querySelector('[data-cpdp-variant-id]');
      var priceEl   = scope.querySelector('[data-cpdp-price]');
      var compareEl = scope.querySelector('[data-cpdp-compare]');
      var unitEl    = scope.querySelector('[data-cpdp-unit]');
      var addBtn    = scope.querySelector('[data-cpdp-add]');
      var addLabel  = scope.querySelector('[data-cpdp-add-label]');
      var stickyP   = document.querySelector('[data-cpdp-sticky-price]');
      var moneyFmt  = scope.getAttribute('data-cpdp-money') || '{{amount}} €';

      function money(cents) {
        var v = (cents / 100).toFixed(2).replace('.', ',');
        return moneyFmt.replace(/\{\{\s*amount\s*\}\}/, v);
      }

      function currentSelection() {
        return Array.prototype.map.call(
          scope.querySelectorAll('[data-cpdp-optgroup]'),
          function (g) {
            var on = g.querySelector('[aria-pressed="true"]');
            return on ? on.getAttribute('data-cpdp-value') : null;
          }
        );
      }

      function findVariant(sel) {
        return variants.filter(function (v) {
          return sel.every(function (val, i) { return val === null || v.options[i] === val; });
        })[0] || null;
      }

      function refresh() {
        var sel = currentSelection();
        var v = findVariant(sel);

        // grise les combinaisons indisponibles, groupe par groupe
        scope.querySelectorAll('[data-cpdp-optgroup]').forEach(function (g, gi) {
          g.querySelectorAll('[data-cpdp-value]').forEach(function (b) {
            var test = sel.slice();
            test[gi] = b.getAttribute('data-cpdp-value');
            var exists = variants.some(function (vv) {
              return test.every(function (val, i) { return val === null || vv.options[i] === val; }) && vv.available;
            });
            b.classList.toggle('is-unavailable', !exists);
          });
        });

        if (!v) {
          if (addBtn) { addBtn.disabled = true; }
          if (addLabel) { addLabel.textContent = 'Combinaison indisponible'; }
          return;
        }

        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price_formatted || money(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = v.compare_formatted || money(v.compare_at_price);
            compareEl.hidden = false;
          } else { compareEl.hidden = true; }
        }
        if (unitEl) unitEl.textContent = v.unit_label || 'TTC';
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? 'Ajouter au panier' : 'Rupture de stock';
        if (stickyP) stickyP.textContent = v.price_formatted || money(v.price);

        // met à jour l'URL sans recharger (utile pour le partage / analytics)
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }

      scope.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cpdp-value]');
        if (!b) return;
        var g = b.closest('[data-cpdp-optgroup]');
        g.querySelectorAll('[data-cpdp-value]').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
        refresh();
      });

      refresh();
    });
  }

  function initAll(root) {
    root = root || document;
    initMarquee(root);
    initFilters(root);
    initGauges(root);
    initGallery(root);
    initVariants(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Rechargement des sections dans l'éditeur de thème Shopify
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
